import { render } from "./productType.vue?vue&type=template&id=03735c2d"
import script from "./productType.vue?vue&type=script&lang=js"
export * from "./productType.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/brandProduct/components/productType.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03735c2d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03735c2d', __exports__)) {
    console.log('reload')
    api.reload('03735c2d', __exports__)
  }
  
  module.hot.accept("./productType.vue?vue&type=template&id=03735c2d", () => {
    console.log('re-render')
    api.rerender('03735c2d', render)
  })

}


export default __exports__